// extracted by mini-css-extract-plugin
export default {"container":"dashboardForSensors_container__TLxdV"};